import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { AnimalsSecured } from '../Types/AnimalStore'

type Store = {
  animalsList: AnimalsSecured[]
  setNewAnimal: (value: AnimalsSecured) => void
  setAnimalsList: (values: AnimalsSecured[]) => void
  deleteAnimal: (id: string) => void
  updateAnimal: (value: Partial<AnimalsSecured>, id: string) => void
}

export const useAnimalStore = create<Store>()(
  devtools(
    (set) => ({
      animalsList: [],
      setNewAnimal: (value) =>
        set((state) => {
          const newData = [...state.animalsList, value]

          return { animalsList: newData }
        }),
      setAnimalsList: (value) => set({ animalsList: value }),
      deleteAnimal: (id) =>
        set((state) => {
          const newData = state.animalsList.filter((animal) => animal.id !== id)

          return { animalsList: newData }
        }),
      updateAnimal: (value, id) =>
        set((state) => {
          const newData = state.animalsList.map((animal) => {
            if (animal.id === id) {
              return { ...animal, ...value }
            } else {
              return animal
            }
          })
          return { animalsList: newData }
        }),
    }),
    { name: 'AnimalStore' },
  ),
)
